import React from 'react';
import { Form, Field } from 'react-final-form';

import { auth } from '../../services/api';
import './Modal.css';

interface State {
  error: boolean | null;
  message: string;
}

class ForgotUsername extends React.Component<{}, State> {
  state: State = { error: null, message: '' };

  sendReset(form: any) {
    this.setState({ error: null });
    auth
      .forgotUsername(form)
      .then((res: any) => {
        if (res.data[0] === undefined) {
          this.setState({ error: true, message: 'User not found' });
        } else {
          this.setState({ error: false, message: `Your username is: ${res.data[0]}` });
        }
      })
      .catch(() => {
        this.setState({ error: true, message: 'An error occured' });
      });
  }

  render() {
    return (
      <div
        className="modal fade"
        id="exampleModalU"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Forgot Username
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {this.state.error !== null ? (
                <div
                  className={this.state.error ? 'alert alert-danger' : 'alert alert-success'}
                  role="alert"
                >
                  {this.state.message}
                </div>
              ) : null}
              <p className="modal-body-text">
                Enter your email and we&#39;ll show you your username:
              </p>
              <Form
                onSubmit={(state) => this.sendReset(state)}
                render={({ handleSubmit }) => (
                  <form autoComplete="on" name="login" onSubmit={handleSubmit}>
                    <div className="flex-container">
                      <div className="flex-item">
                        <Field
                          name="email"
                          component="input"
                          type="text"
                          placeholder="Email"
                          style={{ width: '100%' }}
                        />
                      </div>
                      <div className="flex-item">
                        <button type="submit" className="btn btn-primary">
                          Show username
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              />
            </div>
            <div className="modal-footer" />
          </div>
        </div>
      </div>
    );
  }
}

export default ForgotUsername;
